import apiCLient from '@shared/apiClient'

export const getApiClient = (service = 'search/') => apiCLient.partneringOnePlus(service)
